import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient) { }

  private lddUrlBase = environment.url.lddServiceApiUrl;
  private laddMaster = environment.url.lddMasterApiUrl;

  getNotificationAll(): Observable<any> {
    const getNotificationAll = `${this.lddUrlBase}${environment.url.notification.notificationDetail}`;
    return this.http.get<any>(getNotificationAll);
  }

}
